// extracted by mini-css-extract-plugin
export var markdown = "_sj-0";
export var tableWrapper = "_sj-1";